import { createAIServiceClient } from '@internal/nimbus-ai';
import { createOrgServiceClient } from '@internal/org-service';
import { createBucketServiceClient } from '@nimbus/bucket-service';
import { createNoteServiceClient } from '@nimbus/note-service';
import { createPortalServiceClient } from '@nimbus/portal-service';
import { createTaskServiceClient } from '@nimbus/task-service';
import { createWorkspaceServiceClient } from '@nimbus/workspace-service';
import { generalEnv } from '@nx-frontend/shared/env';

export const portalServiceClient = createPortalServiceClient({
  basePath: `${generalEnv.nextApiPath}/portal-service-proxy/v1`,
});
export const bucketServiceClient = createBucketServiceClient({
  basePath: `${generalEnv.nextApiPath}/bucket-service-proxy/v1`,
});
export const taskServiceClient = createTaskServiceClient({
  basePath: `${generalEnv.nextApiPath}/task-service-proxy/v1`,
});
export const noteServiceClient = createNoteServiceClient({
  basePath: `${generalEnv.nextApiPath}/note-service-proxy/v1`,
});
export const orgServiceClient = createOrgServiceClient({
  basePath: `${generalEnv.nextApiPath}/org-service-proxy/v1`,
});
export const workspaceServiceClient = createWorkspaceServiceClient({
  basePath: `${generalEnv.nextApiPath}/workspace-service-proxy/v1`,
});

export const portalServiceCommonApiClient = createPortalServiceClient({
  basePath: `${generalEnv.nextCommonApiUrl}/proxy/portal-service/v1`,
});

export const aiServiceCommonApiClient = createAIServiceClient({
  basePath: `${generalEnv.nextCommonApiUrl}/proxy/ai-service/v1`,
});
